import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-company-overview-icons',
    templateUrl: './company-overview-icons.component.html',
    styleUrls: ['./company-overview-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyOverviewIconsComponent {
    @Input() isOpened: boolean;
    @Input() locations: any[];
    @Input() linkedinUrl: string;
    @Input() primaryDomain: string;
    @Input() purchaseHistory: any;
}
